export const formatToLocalTime = utcTimeString => {
  const utcDate = new Date(utcTimeString)

  // Function to pad a number with leading zeros
  const padNumber = num => (num < 10 ? '0' + num : num)

  // Get local time Components
  const localHours = utcDate.getHours()
  const localMinutes = utcDate.getMinutes()
  const localDay = utcDate.getDate()
  const localMonth = utcDate.getMonth() + 1 // Month is 0-indexed, so add 1
  const localYear = utcDate.getFullYear()

  // Convert hours to 12-hour format and determine AM/PM
  const ampm = localHours >= 12 ? 'PM' : 'AM'
  const hours12 = localHours % 12 || 12 // Convert 0 to 12

  // Format the date and time in the desired format
  const formattedLocalTime = `${padNumber(hours12)}:${padNumber(localMinutes)} ${ampm} ${padNumber(localDay)} ${new Intl.DateTimeFormat('en-US', { month: 'short' }).format(new Date(localYear, localMonth - 1, localDay))} ${localYear}`

  return formattedLocalTime
}

export function getLastSevenDays() {
  const today = new Date()
  const lastSevenDaysFormatted = []

  const dateFormatter = new Intl.DateTimeFormat('en', { day: '2-digit', month: 'short', year: 'numeric' })

  for (let i = 6; i >= 0; i--) {
    const date = new Date(today)
    date.setDate(today.getDate() - i)

    const formattedDate = dateFormatter.format(date)
    lastSevenDaysFormatted.push(formattedDate)
  }

  return lastSevenDaysFormatted
}

export function getLastThirtyDays() {
  const today = new Date()
  const lastThirtyDaysFormatted = []

  const dateFormatter = new Intl.DateTimeFormat('en', { day: '2-digit', month: 'short', year: 'numeric' })

  for (let i = 29; i >= 0; i--) {
    const date = new Date(today)
    date.setDate(today.getDate() - i)

    const formattedDate = dateFormatter.format(date)
    lastThirtyDaysFormatted.push(formattedDate)
  }

  return lastThirtyDaysFormatted
}

export function responseDateEarningPair(data) {
  let array = data.map(ele => {
    const earning = ele.earning.$numberDecimal
    const { date, month, year } = ele._id
    const newDate = new Date(year, month - 1, date)
    const dateFormatter = new Intl.DateTimeFormat('en', { day: '2-digit', month: 'short', year: 'numeric' })

    return { date: dateFormatter.format(newDate), earning: earning }
  })
  return array
}

export function responseDateCountPair(data) {
  let array = data.map(ele => {
    const count = ele.count
    const { date, month, year } = ele._id
    const newDate = new Date(year, month - 1, date)
    const dateFormatter = new Intl.DateTimeFormat('en', { day: '2-digit', month: 'short', year: 'numeric' })

    return { date: dateFormatter.format(newDate), count: count }
  })
  return array
}

export function earningPairMapping(graphData) {
  let labels = getLastSevenDays()
  const result = labels?.map(day => {
    // const dateStr = day.toISOString()
    const earningData = graphData.find(item => item.date == day)
    // console.log('first', day, '////', earningData)
    const earning = earningData ? earningData.earning : 0
    return { date: day, earning }
  })
  return result
}

export function countPairMapping(graphData, type) {
  let labels = getLastSevenDays()
  if (type === 'monthly') {
    labels = getLastThirtyDays()
  }
  const result = labels?.map(day => {
    // const dateStr = day.toISOString()
    const countData = graphData.find(item => item.date == day)
    // console.log('first', day, '////', earningData)
    const count = countData ? countData.count : 0
    return { date: day, count }
  })
  return result
}